// extracted by mini-css-extract-plugin
export var wrapper = "CardFive-module--wrapper--jiIhZ";
export var header = "CardFive-module--header--2SN6Q";
export var arrow = "CardFive-module--arrow--1LKQk";